// This is a modified version of the snabbdom props module. Unlike the upstream
// module, this implementation does set removed properties to `undefined`
const updateProps = (oldVnode, vnode) => {
	let {
		data: {props: oldProps}
	} = oldVnode;
	let {
		data: {props},
		// eslint-disable-next-line prefer-const
		elm
	} = vnode;

	if (!oldProps && !props) return;

	if (oldProps === props) return;

	oldProps = oldProps || {};
	props = props || {};

	for (const key in oldProps) {
		if (!props.hasOwnProperty(key)) elm[key] = key === 'className' ? '' : undefined;
	}

	for (const key in props) {
		const cur = props[key];
		const old = oldProps[key];
		if (old !== cur && (key !== 'value' || elm[key] !== cur)) elm[key] = cur;
	}
};

export default {
	create: updateProps,
	update: updateProps
};
